// extracted by mini-css-extract-plugin
export var container = "g8_f";
export var heading = "g8_bj";
export var imageContainer = "g8_c5";
export var list = "g8_cY";
export var listImage = "g8_pW";
export var listItem = "g8_pV";
export var listWrapper = "g8_pT";
export var modal = "g8_bh";